import { render } from "./CreateFrequence.vue?vue&type=template&id=3b969c18&scoped=true"
import script from "./CreateFrequence.vue?vue&type=script&lang=js"
export * from "./CreateFrequence.vue?vue&type=script&lang=js"

import "./CreateFrequence.vue?vue&type=style&index=0&id=3b969c18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b969c18"]])

export default __exports__